document.addEventListener("DOMContentLoaded", function() {

    $("table").wrapAll("<div class='table-container' />");

});
